module.exports = __webpack_public_path__ + "img/research-center.902bc7d6.jpg";